import { useQueryClient } from 'react-query';

import { usePost } from '../../utils/reactQuery';
import { ApiRoutesEnum } from '../../utils/routes';

export const useSaveClientFilter = () => {
  const queryClient = useQueryClient();
  return usePost({
    url: ApiRoutesEnum.clientsSaveFilter,
    onSuccess: () => {
      queryClient.invalidateQueries([ApiRoutesEnum.clientsFilters]);
    },
  });
};
